export default __webpack_public_path__ + "1241f4fcc34a5c3c2ca82767dbcec9a5.svg";